import { render, staticRenderFns } from "./SwimLane.vue?vue&type=template&id=6480a37b&"
import script from "./SwimLane.vue?vue&type=script&lang=js&"
export * from "./SwimLane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports